import * as types from './action_types';

export const setPath = (pathname, scrollY) => {
  return (dispatch) => {
    dispatch({ type: types.PATH_SET, pathname: pathname, lastScrollPosition: scrollY });
  }
}

export const setAfterTackPath = (pathname) => {
  return (dispatch) => {
    if (pathname) {
      dispatch({ type: types.AFTER_TACK_PATH_SET, afterTackPathname: pathname });
    }
  }
}

export const resetAfterTackPath = () => {
  return (dispatch) => {
    dispatch({ type: types.AFTER_TACK_PATH_RESET })
  }
}



// WEBPACK FOOTER //
// ./src/stores/navigation/actions.js